import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
// @ts-expect-error untyped module
import isMobile from 'isMobile';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config, secureDocument } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { ALLOWED_DESCRIPTION_TAGS } from '../../constants/OrderDescription';
import { jsx as _jsx } from "react/jsx-runtime";
const OrderDescription = ({
  checkoutSession
}) => {
  if (!checkoutSession.descriptionHtml) {
    return null;
  }
  const descriptionHtml = () => {
    const sanitizedDescription = sanitize(checkoutSession.descriptionHtml, Object.assign({}, config.HTML, {
      elements: ALLOWED_DESCRIPTION_TAGS,
      attributes: {},
      dom: secureDocument
    }));
    return /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: sanitizedDescription
      }
    });
  };
  return /*#__PURE__*/_jsx(CardWrapper, {
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(CardSection, {
      padding: "600",
      children: isMobile.any ? /*#__PURE__*/_jsx(ExpandableText, {
        children: descriptionHtml()
      }) : descriptionHtml()
    })
  });
};
export default OrderDescription;